import { createRequestTypes } from 'common/websocket-redux';

export const INIT_GEOLOCATION = 'member/INIT_GEOLOCATION';
export const GET_GROUP = createRequestTypes('member/GET_GROUP');
